import { Middleware } from 'redux';

import { successReadActivitiesRecent } from '../actions/activity';
import {
  failCalling,
  finishCalling,
  noInternetCalling,
  startCalling
} from '../actions/network';
import GetActivitiesRecent from '../apis/GetActivitiesRecent';

const MIDDLEWARE = 'activities';

const ActivitiesMiddleware: Middleware = store => next => action => {
  switch (action.type) {
    case 'READ_ACTIVITIES_RECENT':
      readActivitiesRecent(store, action);
      break;
  }
  next(action);
};

const readActivitiesRecent = (store: any, action: any) => {
  const METHOD = 'readActivitiesRecent';
  console.log(MIDDLEWARE + ':' + 'Call API: GetActivitiesRecent');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetActivitiesRecent();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(store.getState().Account).then(
        activities => {
          store.dispatch(successReadActivitiesRecent(activities));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

export default ActivitiesMiddleware;



// WEBPACK FOOTER //
// ./src/middlewares/activities.ts